module.exports = __webpack_public_path__ + "media/images/nicklpass-logo-white-3c41e2adc9676e324a14ce534686b08b.png";